// Класс поиска, зависит от библиотеки lunr
import lunr from 'lunr';
import bases from './bases';
require('lunr-languages/lunr.stemmer.support')(lunr);
require('lunr-languages/lunr.multi')(lunr);
require('lunr-languages/lunr.ru')(lunr);
require('lunr-languages/lunr.pt')(lunr);
require('lunr-languages/lunr.it')(lunr);

import defaultLanguage from './language.js';

export default class Search {
  constructor(lang) {
    this.language = lang || defaultLanguage;
    this.init();
  }

  init() {
    const { language } = this;
    this.index = lunr(function index() {
      this.use(lunr.multiLanguage('en', 'ru', 'pt', 'it'));
      this.field(language);
      this.ref('id');
      bases.base.forEach((item) => {
        this.add(item);
      });
    });
  }

  make(q) {
    return this.index.search(`${q}`);
  }
}



// WEBPACK FOOTER //
// ./public/scripts/webpack/SearchClass.js